import React from "react";
import Div from "../../../../widget/common/ui/Div";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import Center from "../../../../widget/common/ui/Center";
import { Position, Stack } from "../../../../widget/common/ui/Stack";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import {
  HomeMenuType,
  SocialType,
} from "../../../../provider/home/HomeContextProvider";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { Col } from "react-bootstrap";
import { textCase } from "../../../../service/ui/UI";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { useDispatch } from "react-redux";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";
import { BranchInfoGuest } from "../../../../model/home_guest_user/GuestBranchInfoModel";
import { appRoutes } from "../../../../routes/routes";
import HomeGuestUserProvider from "../../../../provider/home_guest_user/guest_home/HomeGuestUserProvider";
import { setBranchListScreenName } from "../../../../libraries/state_reducers/branch/BranchListReducer";
import { routeName as routeNameHomeGuest } from "../HomeGuestUserScreen";
import AppConfigService from "../../../../service/app_config/AppConfigService";

export const HomeGuestUserBranchLogo = (props: {
  type: number;
  branchDetail: BranchInfoGuest;
}) => {
  const dispatch = useDispatch();
  const type: number = props.type;
  const branchDetail: BranchInfoGuest = props.branchDetail;

  const onClickSwicthBranch = () => {
    dispatch(setBranchListScreenName({ screenName: routeNameHomeGuest }));
    dispatch(
      addModal({
        id: ModalKeys.list_choose_branch,
        title: AppTranslation.text("choose_preferred_branch"),
        screenMobileView: type !== 3,
      })
    );
  };

  return (
    <Center>
      <Stack>
        {branchDetail != null && (
          <LogoRound
            url={
              branchDetail?.branch_logo_url! ||
              AppConfigService.get("company_logo")
            }
            size={type === 1 ? 73 : type === 2 ? 130 : 160}
            name={branchDetail?.title!}
          />
        )}

        <Position bottom={0} right={0}>
          <IconCircleFilledIcon
            name="swicth2"
            size={type === 1 ? 27 : 39}
            color={AppTheme.white}
            handleClick={() => onClickSwicthBranch()}
          />
        </Position>
      </Stack>
    </Center>
  );
};

export const HomeGuestUserBranchInfo = (props: {
  type: number;
  branchDetail: BranchInfoGuest;
  contactList: Array<string> | undefined;
}) => {
  const type: number = props.type;
  const branchDetail: BranchInfoGuest = props.branchDetail;
  const contactList: Array<string> | undefined = props.contactList;

  let buildingNoName: Array<string> = [
    branchDetail?.building_number!,
    branchDetail?.building_name!,
  ];

  let streetAreaName: Array<string> = [
    branchDetail?.street_name!,
    branchDetail?.area_name!,
  ];

  let cityStateCountryName: Array<string> = [
    branchDetail?.city_name!,
    branchDetail?.state_name!,
    branchDetail?.country_name!,
  ];

  buildingNoName = buildingNoName.filter((el) => el);
  streetAreaName = streetAreaName.filter((el) => el);
  cityStateCountryName = cityStateCountryName.filter((el) => el);

  return (
    <>
      {branchDetail != null && (
        <Div>
          <TextBlock
            fontName="medium"
            fontSize="20_21"
            textColor="theme-label"
            className="text-center"
          >
            {textCase(branchDetail?.title!)}
          </TextBlock>

          <SpacingHeight value={type === 1 ? 25 : type === 2 ? 28 : 24} />

          {contactList !== undefined && (
            <TextBlock
              fontName="book"
              fontSize="17_18"
              textColor="theme-label"
              className="text-center"
            >
              {textCase(contactList.join(" | "))}
            </TextBlock>
          )}

          <SpacingHeight value={type === 1 ? 15 : 31} />

          <TextBlock
            fontName="book"
            fontSize="14_15"
            textColor="theme-sublabel"
            className="text-center"
          >
            {buildingNoName.length > 0 && (
              <>
                {textCase(buildingNoName.join(", "))}
                <br />
              </>
            )}
            {streetAreaName.length > 0 && (
              <>
                {textCase(streetAreaName.join(", "))}
                <br />
              </>
            )}
            {cityStateCountryName.length > 0 && (
              <>
                {textCase(cityStateCountryName.join(", "))}
                <br />
              </>
            )}
          </TextBlock>
        </Div>
      )}
    </>
  );
};

export const HomeGuestUserSocial = (props: {
  type: number;
  socialLinks: Array<SocialType> | undefined;
}) => {
  const type: number = props.type;
  const socialLinks: Array<SocialType> | undefined = props.socialLinks;
  const dispatch = useDispatch();

  const handleClickMore = () => {
    dispatch(
      addModal({
        id: ModalKeys.home_guest_social_list_modal,
        title: AppTranslation.text("social_media_links"),
        size: "md",
        allowBottomSheet: true,
        bottomSheetHideTitle: true,
      })
    );
  };

  return (
    <Center>
      {(socialLinks?.slice(0, 5) ?? []).map((item, index) => (
        <IconCircleFilledIcon
          key={index}
          name={item.icon}
          className={`mx-${type === 3 ? 2 : 1}`}
          color={AppTheme.white}
          size={type === 1 ? 30 : 50}
          handleClick={() => UtilityHelper.navigateTab(item.link)}
        />
      ))}

      {(socialLinks ?? []).length > 5 && (
        <IconCircleFilledIcon
          name="plus"
          className={`mx-${type === 3 ? 2 : 1}`}
          color={AppTheme.white}
          size={type === 1 ? 20 : 40}
          handleClick={() => handleClickMore()}
        />
      )}
    </Center>
  );
};

export const HomeGuestUserMenu = (props: {
  type: number;
  branchDetail: BranchInfoGuest;
  homeMenu: Array<HomeMenuType>;
  contactList: Array<string> | undefined;
}) => {
  const dispatch = useDispatch();

  const type: number = props.type;
  const branchDetail: BranchInfoGuest = props.branchDetail;
  const homeMenu: Array<HomeMenuType> = props.homeMenu;
  const contactList: Array<string> | undefined = props.contactList;

  const handleClick = (menuName: string, menuTitle: string) => {
    if (menuName === "general") {
      if (type === 3) {
        dispatch(
          addModal({
            id: ModalKeys.home_guest_general_form,
            title: "general_form",
          })
        );
      } else {
        HomeGuestUserProvider.navigate(appRoutes.routeNameGuestFormGeneral);
      }
    } else if (menuName === "feedback") {
      if (type === 3) {
        dispatch(
          addModal({
            id: ModalKeys.home_guest_feedback_form,
            title: "feedback_form",
          })
        );
      } else {
        HomeGuestUserProvider.navigate(appRoutes.routeNameGuestFormFeedback);
      }
    } else if (menuName === "products") {
      if (type === 3) {
        dispatch(
          addModal({ id: ModalKeys.home_products_modal, title: menuTitle })
        );
      } else {
        HomeGuestUserProvider.navigate(appRoutes.routeNameProducts);
      }
    } else if (menuName === "email") {
      if (type === 3) {
        dispatch(
          addModal({ id: ModalKeys.home_email_modal, title: menuTitle })
        );
      } else {
        HomeGuestUserProvider.navigate(appRoutes.routeNameEmail);
      }
    } else if (menuName === "call") {
      dispatch(
        addModal({
          id: ModalKeys.home_guest_call_modal,
          title: AppTranslation.text("phone_number"),
          size: "md",
          allowBottomSheet: true,
          bottomSheetHideTitle: true,
        })
      );
    } else if (menuName === "location") {
      UtilityHelper.naviagteGoogleMap(
        branchDetail?.latitude!,
        branchDetail?.longitude!
      );
    }
  };

  const renderMenu = () => {
    return homeMenu.map((menu, index) => {
      let isActive = true;
      const menuName: string = menu.name;

      if (
        (menuName === "products" &&
          branchDetail?.branch_products_details?.status === "1" &&
          UtilityHelper.isEmpty(
            branchDetail?.branch_products_details?.media_details?.file_name!
          )) ||
        (menuName === "products" &&
          branchDetail?.branch_products_details?.status === "0")
      ) {
        isActive = false;
      } else if (
        menuName === "email" &&
        (branchDetail?.email_list! ?? []).length === 0
      ) {
        isActive = false;
      } else if (menuName === "app") {
        isActive = false;
      } else if (menuName === "call" && (contactList ?? []).length === 0) {
        isActive = false;
      } else if (menuName === "location") {
        if (
          UtilityHelper.isEmpty(branchDetail?.latitude!) &&
          UtilityHelper.isEmpty(branchDetail?.longitude!)
        ) {
          isActive = false;
        }
      }

      return (
        <Col
          key={index}
          className={`pb-${type === 3 ? 4 : 3} pt-0 pt-md-2`}
          role={`${isActive ? "button" : ""}`}
          xs={4}
          md={2}
          xl={1}
          style={{ opacity: isActive ? 1 : 0.3 }}
          onClick={() => handleClick(menuName, menu.title)}
        >
          <Center>
            <IconCircleFilledIcon
              name={menu.icon}
              className="mx-2"
              color={AppTheme.white}
              size={type === 1 ? 50 : 65}
            />
          </Center>
          <SpacingHeight value={type === 1 ? 5 : type === 2 ? 17 : 20} />

          <TextBlock
            fontName={`${type === 3 ? "book" : "medium"}`}
            fontSize="13_14"
            textColor="theme-label"
            className="text-center"
          >
            {AppTranslation.text(menu.title)}
          </TextBlock>
        </Col>
      );
    });
  };

  return <Center className="row ">{renderMenu()}</Center>;
};
